export const swapUrlOrigin = (url, origin) => {
  const _url = new URL(url);
  const newUrl = new URL(_url.pathname + _url.search, origin ?? window.origin);
  return newUrl;
};
